Vendd.Scripts.load(function () {

    initMainMenuTwo();

});

function initMainMenuTwo() {

    var $wrapper = $('.header-region .x-main-menu-two');

    var $firstLevel = $('.nav-1 > li > a', $wrapper);

    initMainMenuTwoEffects($firstLevel);

    $(".x-main-menu-two").on("mouseleave", function (e) {
        $('.nav-1 > li', $wrapper).removeClass('hovered');
        $('.site-overlay').removeClass('visible');
    });

    $('.x-main-menu-two .nav-1 > li.hasChildren >.title').click(function (e) {
        if ($(window).outerWidth() > 719) {
            e.preventDefault();
            var $el = $(this).parent();
            $el.siblings(".hovered").removeClass('hovered');
            $el.addClass('hovered').siblings('.hovered').removeClass('hovered');

            if ($el.hasClass('hasChildren')) {
                $('.site-overlay').show().addClass('visible');
            }
            else {
                $('.site-overlay').hide().removeClass('visible');
            }
        }
    });
    $(window).resize(function () {
        if ($(window).outerWidth() < 1440) {
            $('.site-overlay').hide().removeClass('visible');
        }
    });
 
}

function initMainMenuTwoEffects($submenus) {

    if ($submenus.length == 0)
        return;

    var config = {
        sensitivity: 10,
        interval: 80,
        over: mouseenter,
        timeout: 200,
        out: mouseleave
    };


    function mouseenter() {
        var $el = $(this);
        $el.siblings(".hovered").removeClass('hovered');
        $el.addClass('hovered').siblings('.hovered').removeClass('hovered');

        if ($el.hasClass('hasChildren')) {
            $('.site-overlay').addClass('visible');
        }
        else {
            $('.site-overlay').removeClass('visible');
        }
    }

    function mouseleave() {
        return;
    }

    $submenus.parent().hoverIntent(config);
}